import { Share, SharesTitle } from 'types';

export const getTitleByShare = (sharesTitles: SharesTitle[], share: Share) =>
  sharesTitles?.find((title: SharesTitle) =>
    title?.shares?.some((s) => s === share?._id)
  );
